import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import {STEP_SESSION_CONTACT, STEP_SESSION_DETAILS, STEP_SESSION_VENUES} from "../../../constants";
import {FormProgress} from 'cw-styleguide-react';

class CoursesSessionsFormProgress extends Component {
  render() {
    return (
      <FormProgress step={this.props.step} steps={[
        {
          id: STEP_SESSION_DETAILS,
          title: this.props.t('local:view.courses.create.tabs.sessions.step.details.label'),
          completed: this.props.isEditing,
          onClick: (e) => this.props.handleSetStep(e, STEP_SESSION_DETAILS)
        },
        {
          id: STEP_SESSION_CONTACT,
          title: this.props.t('local:view.courses.create.tabs.sessions.step.contact.label'),
          completed: this.props.isEditing,
          onClick: (e) => this.props.handleSetStep(e, STEP_SESSION_CONTACT)
        },
        {
          id: STEP_SESSION_VENUES,
          title: this.props.t('local:view.courses.create.tabs.sessions.step.venues.label'),
          completed: this.props.isEditing,
          onClick: (e) => this.props.handleSetStep(e, STEP_SESSION_VENUES)
        }
      ]}/>
    );
  }
}
export default withTranslation('local')(CoursesSessionsFormProgress);
